import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import PropTypes from "prop-types";
import { List, ListItem } from "@xo-union/tk-component-fields";
import { compose } from "@xo-union/react-css-modules";
import styles from "../../css/styles.css";
import VendorShape from "../../shapes/VendorShape.js";
import GoogleEstablishmentShape from "../../shapes/GoogleEstablishmentShape.js";
var itemClasses = compose({
  item: styles['suggestion-item']
});

var SuggestionList = function SuggestionList(_ref) {
  var emptyLabel = _ref.emptyLabel,
      suggestions = _ref.suggestions,
      Suggestion = _ref.Suggestion;
  var items = React.createElement(ListItem, {
    disabled: true
  }, emptyLabel);

  if (suggestions.length > 0) {
    items = _mapInstanceProperty(suggestions).call(suggestions, function (suggestion, idx) {
      return React.createElement(ListItem, {
        key: suggestion.id,
        suggestion: suggestion,
        position: idx,
        classes: itemClasses
      }, React.createElement(Suggestion, {
        suggestion: suggestion
      }));
    });
  }

  return React.createElement(List, null, items);
};

SuggestionList.defaultProps = {
  suggestions: []
};
process.env.NODE_ENV !== "production" ? SuggestionList.propTypes = {
  emptyLabel: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape(VendorShape), PropTypes.shape(GoogleEstablishmentShape)])),
  Suggestion: PropTypes.func.isRequired
} : void 0;
export default SuggestionList;